import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';

export const AppLayout = () => {
  const { user, loading, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin w-8 h-8 border-2 border-slate-900 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect super_admin to platform dashboard if they try to access tenant pages
  if (isSuperAdmin() && location.pathname !== '/platform') {
    return <Navigate to="/platform" replace />;
  }

  // Redirect tenant users away from platform page
  if (!isSuperAdmin() && location.pathname === '/platform') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="main-content">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};
